import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        const message = error.error?.error?.message?.[0];
        if (
          error.status === 401 &&
          ['token_invalid', 'token_not_provided', 'token_expired'].includes(message)
        ){
          localStorage.clear();
          this.userService.authUser = null;
          // Only reload the page if we are not on login page
          if (!this.router.url.includes('/login')) {
            location.reload();
          }
        }
        return throwError(() => error);
      }),
    );
  }
}


